import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { number, func, bool } from 'prop-types';

import { actionCreators as homeActions } from '~screens/Dashboard/screens/Home/redux/actions';
import { formatPrice } from '~utils/number';
import TipPercentageButton from '~screens/Dashboard/screens/Home/screens/Checkout/components/TipSelection/components/TipPercentageButton/layout';
import { PERCENT_100 } from '~screens/Dashboard/screens/Home/screens/Checkout/components/TipSelection/constants';

function TipPercentageButtonContainer({
  index,
  percentage,
  handleSelect,
  isSelected,
  subtotal,
  totalTip,
  setTip
}) {
  const tipAmount = useMemo(() => Math.round(subtotal * (percentage / PERCENT_100)), [percentage, subtotal]);

  useEffect(() => {
    if (isSelected) {
      setTip(tipAmount || totalTip);
    }
  }, [isSelected, setTip, tipAmount, totalTip]);

  const handleClick = () => {
    handleSelect(index);
  };

  return (
    <TipPercentageButton
      percentage={percentage}
      totalTip={formatPrice(totalTip || tipAmount)}
      handleSelect={handleClick}
      isSelected={isSelected}
    />
  );
}

TipPercentageButtonContainer.propTypes = {
  handleSelect: func,
  index: number,
  isSelected: bool,
  percentage: number,
  setTip: func,
  subtotal: number,
  totalTip: number
};

const mapStateToProps = state => ({
  subtotal: state.home.shoppingCart.subtotal
});

const mapDispatchToProps = dispatch => ({
  setTip: tip => dispatch(homeActions.setTip(tip))
});

export default connect(mapStateToProps, mapDispatchToProps)(TipPercentageButtonContainer);
